import { render, staticRenderFns } from "./CandidateInterview.vue?vue&type=template&id=2559ca2c&scoped=true&"
import script from "./CandidateInterview.vue?vue&type=script&lang=js&"
export * from "./CandidateInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559ca2c",
  null
  
)

export default component.exports